<template>
	<div class="sa-free-page">
		<div class="sa-free-page-header"><sa-nav-bar :pageTitle="pageTitle" :userName="nominativoUtente" :idUtente="user.id" :hidden="hiddenNavBar" /></div>
		<div class="sa-free-page-body">
			<div class="sa-application-home">
				<b-row class="text-center">
					<b-col style="margin-top: 30px" v-for="application in applications" xs="12" sm="6" md="4" lg="4" xl="3" :key="application.id">
						<div :class="'sa-application-home-app-box ' + 'sa-application-home-app-box-' + application.id" @click="onClickApplication(application)">
							<img class="sa-application-home-img" :src="'/css/' + application.id + '/images/logo.png'" alt="" />
							<p class="sa-application-home-label">{{ application.name }}</p>
						</div>
					</b-col>
				</b-row>
			</div>
		</div>
		<div class="sa-free-page-footer">Footer</div>
		<sa-modal-loading ref="cmpSaModalLoading" />
	</div>
</template>

<script>
import { SaNavBar } from "../../../template/layout";
import { SaModalLoading } from "../../utility";
import axios from "axios";
export default {
	components: { SaNavBar, SaModalLoading },
	data() {
		return {
			pageTitle: "GHS",
			nominativoUtente: "",
			user: { id: null },
			hiddenNavBar: false,
			applications: [
				{ id: "graffidi", name: "Graffidi" },
				{ id: "cot", name: "C.O.T." },
				{ id: "catomaior", name: "Catomaior" },
				{ id: "nurity", name: "Nurity" },
				{ id: "pervacare", name: "Pervacare" },
				{ id: "ghs", name: "Gesan Healt Suite" },
			],
		};
	},
	async mounted() {
		this.$refs["cmpSaModalLoading"].show();
		await this.loadUserData();
	},
	methods: {
		async loadUserData() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + "/users/profile";

			await axios
				.get(link)
				.then((response) => {
					me.user = response.data.data;
					me.nominativoUtente = me.user.lastname + " " + me.user.firstname;
					me.$refs["cmpSaModalLoading"].close();
				})
				.catch(() => {
					me.$refs["cmpSaModalLoading"].close();
				});
		},
		async onClickApplication(application) {
			sessionStorage.setItem("applicationInfo", JSON.stringify(application));
			//this.$router.go();
			// console.log(this.$router.history.current);
			// let newPath = this.$router.history.current.fullPath.replace(this.$router.history.current.path, "#/home");
			// console.log(this.$router.history.current.fullPath);
			// console.log(this.$router);
			// //window.location.assign(newPath);
			// window.location = newPath;
			// window.location.assign(r.href)
			this.$router.replace({ path: "/home", force: true }).catch((err) => {
				err;
			});
			//this.$router.replace({ name: 'Home', force: true })
			// await this.$router.push("/home");
			// console.log("Fatto");
		},
	},
};
</script>

<style>
.sa-application-home {
	margin-left: 3rem;
	margin-right: 3rem;
}
.sa-application-home-img {
	width: 150px;
}
.sa-application-home-app-box {
	border-width: 2px;
	border-style: solid;
	margin: 0px 40px;
	border-radius: 30px;
	padding-top: 10px;
}
.sa-application-home-app-box:hover {
	background-color: #dbdbdb;
	cursor: pointer;
}
.sa-application-home-label {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	margin-top: 10px;
	font-size: 1.2rem;
	font-variant: petite-caps;
}
.sa-application-home-app-box-graffidi {
	border-color: #133b68;
	color: #133b68;
}
.sa-application-home-app-box-cot {
	border-color: #133b68;
	color: #133b68;
}
.sa-application-home-app-box-catomaior {
	border-color: #2eafb4;
	color: #2eafb4;
}
.sa-application-home-app-box-nurity {
	border-color: #00a3ff;
	color: #00a3ff;
}
.sa-application-home-app-box-pervacare {
	border-color: #2394c2;
	color: #2394c2;
}
</style>
